<template>
  <div class="content container__form-forum-reply">
    <forum-user ref="forum__user" :user-forum="user" :learning-unit="learningUnit"> </forum-user>

    <div class="content-indent">
      <forum-form
        ref="forum-form__container"
        button-title="Reply"
        :reference-meta="referenceMeta"
        :provider="submit"
        @submit:invalid="onSubmitInvalid"
        @submit:success="onSubmitSuccess"
        @submit:error="onSubmitError"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import ForumThreads from '@/models/ForumThreads';
import LearningUnit from '@/models/LearningUnit';
import ForumForm from '@/components/Forum/ForumForm.vue';
import ForumUser from '@/components/Forum/ForumUser.vue';
import User from '@/models/User';

export default {
  components: {
    ForumForm,
    ForumUser
  },

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    forumThread: {
      type: ForumThreads,
      required: true
    },

    user: {
      type: User,
      required: true
    }
  },

  data() {
    return {
      referenceMeta: {
        ref: 'forum-threads',
        refId: null,
        field: 'images'
      }
    };
  },

  methods: {
    async submit(body) {
      const { content } = body;

      const { response } = await ForumThreads.api().createReplyThread(this.forumThread.id, {
        content
      });

      const { data = {} } = response;

      return ForumThreads.find(data.id);
    },

    async onSubmitSuccess(insertedForumThread) {
      await ForumThreads.api().getForumThreadById(
        this.forumThread.forum_id,
        insertedForumThread.id
      );

      this.$emit('submit:success', insertedForumThread);

      this.$toast.success('Forum was updated successfully');
    },

    onSubmitError() {
      this.$toast.error('Cannot reply, please try again');
    },

    onSubmitInvalid() {
      this.$toast.error('Cannot reply');
    },

    onCancel() {
      return this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
.content-indent {
  border-left: 1px solid var(--gray);
  margin-left: 22px;
  padding-left: 34px;
}
</style>
